$(document).ready(function() {
  $('#AddToCartForm--product-template .shopify-payment-button').click(function() {
    $('.shopify-payment-button').addClass('disabled');
    $('.return-policy-container').show();
  });
  
  $('#return-policy').click(function(){
    if($(this).is(':checked')){
      $('.shopify-payment-button').removeClass('disabled');
      $('.additional-checkout-buttons').removeClass('disabled');
      $('.shopify-payment-button').addClass('ready');
      $('.additional-checkout-buttons').addClass('ready');
      $('.template-cart .cart__checkout').removeClass('disabled');
      $('#return-policy').parents('p.line-item-property__field').removeClass('check-alert');
      $.post('/cart/update.js', { attributes : { "return-policy": "agree" } } );
    }
    else{
      $('.additional-checkout-buttons').addClass('disabled');
      $('.additional-checkout-buttons').removeClass('ready');
      $('.shopify-payment-button').addClass('disabled');
      $('.shopify-payment-button').removeClass('ready');  
      $('.template-cart .cart__checkout').addClass('disabled');
    }
  });

  $(".template-cart .cart__checkout").click(function(e){      
    if($('#return-policy').is(':checked')){
      $('.template-cart .cart__checkout').trigger('click');
    }
    else{        
      e.preventDefault();
      $('#return-policy').parents('div.return-policy-container').addClass('check-alert');        
      return false;
    }
  });
  $(".template-cart .additional-checkout-buttons").click(function(e){      
    if($('#return-policy').is(':checked')){

    }
    else{        
      e.preventDefault();
      $('#return-policy').parents('div.return-policy-container').addClass('check-alert');        
      return false;
    }
  });
});
